import React from 'react';
import OmCircularProgress from '../ui/OmCircularProgress';

/**
 * SLA Table Skeleton Loading Component
 * 
 * Displays loading state with animated placeholders while SLA data is being fetched.
 * Matches the structure and styling of the actual SLA dashboard.
 */
const SlaTableSkeleton = () => {
  return (
    <div className="space-y-6">
      {/* Loading Spinner with Message */}
      <div className="flex flex-col items-center justify-center py-16">
        <div className="mb-6">
          <OmCircularProgress 
            indeterminate={true} 
            size="large"
          />
        </div>
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          Loading SLA Dashboard
        </h3>
        <p className="text-gray-600 text-sm">
          Fetching claim tracking data and SLA metrics...
        </p>
      </div>
      
      {/* Summary Stats Skeleton */}
      <div className="bg-white rounded-lg shadow p-6">
        <div className="h-6 w-48 bg-gray-200 rounded animate-pulse mb-4"></div>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="text-center">
              <div className="h-8 w-16 bg-gray-200 rounded animate-pulse mx-auto mb-2"></div>
              <div className="h-4 w-24 bg-gray-200 rounded animate-pulse mx-auto"></div>
            </div>
          ))}
        </div>
      </div>
      
      {/* Filters Skeleton */}
      <div className="bg-white rounded-lg shadow p-6">
        <div className="h-6 w-32 bg-gray-200 rounded animate-pulse mb-4"></div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <div className="h-4 w-24 bg-gray-200 rounded animate-pulse mb-2"></div>
            <div className="h-10 w-full bg-gray-200 rounded-lg animate-pulse"></div>
          </div>
          <div>
            <div className="h-4 w-24 bg-gray-200 rounded animate-pulse mb-2"></div>
            <div className="h-10 w-full bg-gray-200 rounded-lg animate-pulse"></div>
          </div>
        </div>
      </div>
      
      {/* Table Skeleton */}
      <div className="bg-white rounded-lg shadow overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-200">
          <div className="h-6 w-48 bg-gray-200 rounded animate-pulse"></div>
        </div>
        <div className="p-6 space-y-4">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="flex items-center space-x-4">
              <div className="h-4 w-20 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-4 w-32 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-4 w-24 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-4 w-28 bg-gray-200 rounded animate-pulse"></div>
              <div className="flex-1"></div>
              <div className="h-4 w-24 bg-gray-200 rounded animate-pulse"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SlaTableSkeleton;
